"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTh = exports.StyledTd = exports.StyledTr = exports.StyledTable = exports.StyledTableBox = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var StyledTableBox = _styledComponents["default"].div.withConfig({
  displayName: "style__StyledTableBox",
  componentId: "e0k6e9-0"
})(["width:100%;max-height:540px;overflow:auto;border:1px solid rgba(26,28,34,0.1);margin-bottom:20px;"]);

exports.StyledTableBox = StyledTableBox;

var StyledTable = _styledComponents["default"].table.withConfig({
  displayName: "style__StyledTable",
  componentId: "e0k6e9-1"
})(["border-collapse:collapse;width:100%;padding:0;border-radius:4px;overflow:hidden;border:1px solid rgba(26,28,34,0.1);font-size:14px;"]);

exports.StyledTable = StyledTable;

var StyledTr = _styledComponents["default"].tr.withConfig({
  displayName: "style__StyledTr",
  componentId: "e0k6e9-2"
})(["background-color:#fff;border-bottom:1px solid #d2d3d6;box-sizing:border-box;"]);

exports.StyledTr = StyledTr;

var StyledTd = _styledComponents["default"].td.withConfig({
  displayName: "style__StyledTd",
  componentId: "e0k6e9-3"
})(["width:100%;padding:11px 20px;font-size:15px;color:#393f44;"]);

exports.StyledTd = StyledTd;

var StyledTh = _styledComponents["default"].td.withConfig({
  displayName: "style__StyledTh",
  componentId: "e0k6e9-4"
})(["position:relative;font-size:16px;color:#393f44;font-weight:700;white-space:nowrap;padding:11px 20px;"]);

exports.StyledTh = StyledTh;